/* ==========================================================
   Feature Highlights — behavior
   Just the stagger-in scroll animation. Fires once per page load,
   the first time the section reaches the viewport.

   FIX (page lag): this used to depend on GSAP loaded from a
   third-party CDN, with content hidden in CSS until GSAP's animation
   revealed it — on a slow/restricted connection to that CDN, that
   showed up as page lag and content stuck hidden. There is no
   external library and no CDN request anymore — this is plain CSS
   transitions (see feature-highlights.css) turned on by classList
   calls below. Content is fully visible by default regardless of
   whether any of this runs.
   ========================================================== */

(function () {
  "use strict";

  var CONTENT_STAGGER = 0.12;
  var GROUP_DELAY = 0.12;

  function init(root) {
    initStagger(root);
  }

  function initStagger(root) {
    if (root.dataset.stagger === "false") return;
    if (typeof IntersectionObserver === "undefined") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var groupEls = Array.prototype.slice.call(root.querySelectorAll("[data-stagger-group]"));
    groupEls.forEach(function (groupEl, order) {
      var items = Array.prototype.slice.call(groupEl.querySelectorAll("[data-stagger-item]"));
      if (!items.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            playGroup(items, order);
          });
        },
        { threshold: 0 }
      );
      observer.observe(groupEl);
    });
  }

  function playGroup(items, order) {
    var groupDelay = order * GROUP_DELAY;

    items.forEach(function (item, i) {
      item.classList.add("stagger-pre");
      item.style.transitionDelay = (groupDelay + i * CONTENT_STAGGER) + "s";
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        items.forEach(function (item) {
          item.classList.remove("stagger-pre");
          item.classList.add("stagger-in");
        });
      });
    });
  }

  document.querySelectorAll("[data-feature-highlights]").forEach(init);
})();